import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '@/modules/console/lib/api.js';
import { Console } from '@/modules/console/index.jsx';

/**
 * Office-portal-embedded project console.
 *
 * The route is project-less — the console token the office handshake
 * delivers is bound to exactly one project, and /embed/v1/console/context
 * tells us which. Everything else is the standard Console page in embedded
 * mode (no root-plane breadcrumb lookups).
 */
export default function EmbedConsole() {
  const { t } = useTranslation(['common']);
  const [context, setContext] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.get('embed/v1/console/context').then(({ success, response, message }) => {
      if (cancelled) return;
      if (success && response?.project_id) {
        setContext(response);
      } else {
        setError(message || t('common:embed.noConsoleAccess'));
      }
    });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) {
    return (
      <div className="flex h-screen items-center justify-center px-6 text-center text-sm text-muted-foreground">
        {error}
      </div>
    );
  }
  if (!context) {
    return (
      <div className="flex h-screen items-center justify-center text-sm text-muted-foreground">
        {t('common:embed.consoleLoading')}
      </div>
    );
  }
  return (
    <div className="h-screen overflow-y-auto bg-background px-6 py-6">
      <Console
        projectId={context.project_id}
        projectName={context.project_name}
        embedded
      />
    </div>
  );
}
